"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    cdfPayUserPortalUrl: 'https://user.qa.test.cdfpay.flexischools.com.au/',
    supplierPortalUrl: 'https://supplier.qa.test.flexischools.com.au',
    supplierPortalV4Url: 'http://localhost:4000', // TODO: come back and edit this later
    opsPortalUrl: 'https://ops.qa.test.flexischools.com.au',
    ssspUrl: 'https://qa.test.flexischools.com.au/SupplierPortal',
    supplierAdminBaseUrl: 'https://qa.test.flexischools.com.au/SupplierPortal',
    flexischoolsApiBaseUrl: 'https://qa.test.flexischools.com.au/FM_Services/',
    adminApiBaseUrl: 'https://qa.test.flexischools.com.au/FM_Services/',
    legacyOrdringSite: 'https://qa.test.flexischools.com.au/FM/m/Home/Legacy',
    legacyBaseUrl: 'https://qa.test.flexischools.com.au/',
    flexibuzzWebBaseUrl: 'https://buzz.qa.test.flexischools.com.au/',
    flexibuzzNewsFeedId: 35,
    flxBusinessIdInBuzz: 9627,
    userApiBaseUrl: 'https://api.user.qa.test.flexischools.com.au/',
    bffBaseUrl: 'https://servicebff.qa.test.flexischools.com.au/api/v1.0/graphql/',
    bffHealthcheckBaseUrl: 'https://servicebff.qa.test.flexischools.com.au/',
    signalRBaseUrl: 'https://clientnotifications.qa.test.flexischools.com.au/signalrhub/notifications',
    bffCommsBaseUrl: 'https://bffcomms.qa.test.flexischools.com.au/api/v1.0/',
    firebase: {
        apiKey: 'AIzaSyDVR0lGN63AevXIaXpZAUZ8prdKvvjneLo',
        authDomain: 'flexischools-qa-app.firebaseapp.com',
        databaseURL: 'https://flexischools-qa-app.firebaseio.com',
        projectId: 'flexischools-qa-app',
        storageBucket: 'flexischools-qa-app.appspot.com',
        messagingSenderId: '364285062482',
        appId: '1:364285062482:web:1a0116d25b1f8f6220de8b',
        measurementId: 'G-Q8FNB019FK',
    },
    launchDarklyClientId: '6195d4c05b2be8144fea36a0',
    launchDarklyDefaultUser: '21cdab01-3279-4141-b0d3-e45ab2c33c98',
    openInAppLink: 'https://flexischoolsqa.page.link/gpdR',
    orderingBffBaseUrl: 'https://bffordering.qa.test.flexischools.com.au/api/v1.0/',
    supplierBffBaseUrl: 'https://bffsupplier.qa.test.flexischools.com.au/api/v1.0/',
    supplierBffV2BaseUrl: 'https://bffsupplier.qa.test.flexischools.com.au/api/v2.0/',
    opsBffBaseUrl: 'https://bffops.qa.test.flexischools.com.au/api/v1.0/',
    TimeRegionKeyEnum: {
        Sydney: '3775a3c8-098e-41b4-9a90-824c376450e1',
        Melbourne: '3775a3c8-098e-41b4-9a90-824c376450e1',
        Canberra: '3775a3c8-098e-41b4-9a90-824c376450e1',
        Hobart: '3775a3c8-098e-41b4-9a90-824c376450e1',
        Brisbane: '819084c3-ec6d-4bec-b7e1-595099c210c8',
        Adelaide: '88758f82-8b40-43d8-b0c8-5109fc703261',
        Perth: '0c89a3ac-3eaa-444b-b378-301939089e5b',
        UTC: 'ee83569b-4f5c-432e-967a-60ed48a92bd3',
        Darwin: '56619b3c-fec9-423c-a0ed-e12f8e68fc20',
    },
    GtmKey: 'GTM-58LXMJTR',
    paypalClientId: 'AXpawxOMj7X2c7fN6N6JUlaAv03HMQ6lIpWhhDkjIquECHTtCrL1GsVbS4NBwtNu_KCiQAgKaHHNsihN',
    env: 'QA',
};
//# sourceMappingURL=AppConfig.js.map